import type { Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export function glassSurface(theme: Theme) {
  return {
    backgroundColor: alpha(theme.palette.background.default, 0.95),
    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.4)}`,
    '@supports ((backdrop-filter: blur(12px)) or (-webkit-backdrop-filter: blur(12px)))': {
      backgroundColor: alpha(theme.palette.background.default, 0.6),
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
    },
  };
}
